import { Dispatch, makeActionCreator } from "../../store/types";
import { ProductStyle } from "../../models";

export const SET_STYLES = "step2/SET_STYLES";
export const SET_STYLES_LOADING = "step2/SET_STYLES_LOADING";
export const SET_DESC_VAL = "step2/SET_DESCRIPTION_VALUE";
export const SET_STYLE_SELECTION = "step2/SET_CHOSEN_STYLE";
export const RESET = "step2/RESET";

export const setDescVal = makeActionCreator<
  string
>(SET_DESC_VAL as typeof SET_DESC_VAL);
const setStylesLoading = makeActionCreator<
  boolean
>(SET_STYLES_LOADING as typeof SET_STYLES_LOADING);
const setStyles = makeActionCreator<
  ProductStyle[]
>(SET_STYLES as typeof SET_STYLES);
export const setStyleSelection = makeActionCreator<
  ProductStyle | undefined
>(SET_STYLE_SELECTION as typeof SET_STYLE_SELECTION);
export const reset = makeActionCreator(RESET as typeof RESET);

// TODO: proper stateful error handling
export const fetchStyles = () => async (dispatch: Dispatch, _, http) => {
  dispatch(setStylesLoading(true));

  // TODO: Maybe paginate later
  const params = { limit: 100 };

  try {
    const result: any = await http.get("data/styles", { params });

    dispatch(setStyles(result.data || []));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setStylesLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/WizardStyleChoice/actions.ts